import PropTypes from "prop-types";

const ListFiltersLayout = ({
  statusFilterSection,
  paymentStatusFilterSection,
  dateFilterSection,
  searchFilterSection,
  skeletonSection,
}) => (
  <div className="d-flex flex-wrap my-4 gap-4">
    {skeletonSection || (
      <>
        {statusFilterSection}

        {paymentStatusFilterSection}

        {dateFilterSection}

        {searchFilterSection}
      </>
    )}
  </div>
);

ListFiltersLayout.defaultProps = {
  skeletonSection: null,
  paymentStatusFilterSection: null,
};

ListFiltersLayout.propTypes = {
  skeletonSection: PropTypes.node,
  statusFilterSection: PropTypes.node.isRequired,
  paymentStatusFilterSection: PropTypes.node,
  dateFilterSection: PropTypes.node.isRequired,
  searchFilterSection: PropTypes.node.isRequired,
};

export default ListFiltersLayout;
